module.exports = __webpack_public_path__ + "img/night--white.12af16e2.svg";